export enum Errors {
  Default = 'Что-то пошло не так, попробуйте снова.'
}
